export default __webpack_public_path__ + "static/media/push1.f6df7d52.gif";